import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.string.sub.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { map } from 'rxjs';
import { BN_ONE, BN_ZERO } from '@polkadot/util';
import { memo } from "../util/index.js";
export function erasHistoric(instanceId, api) {
  return memo(instanceId, function (withActive) {
    return api.queryMulti([api.query.staking.activeEra, api.query.staking.historyDepth]).pipe(map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          activeEraOpt = _ref2[0],
          historyDepth = _ref2[1];

      var result = [];
      var max = historyDepth.toNumber();
      var activeEra = activeEraOpt.unwrapOrDefault().index;
      var lastEra = activeEra;

      while (lastEra.gte(BN_ZERO) && result.length < max) {
        if (lastEra !== activeEra || withActive === true) {
          result.push(api.registry.createType('EraIndex', lastEra));
        }

        lastEra = lastEra.sub(BN_ONE);
      } // go from oldest to newest


      return result.reverse();
    }));
  });
}